// returns two variables, isAllLost which is true if all locators in array is lost, and hasAtLeastOneLost which returns true if one of the locators is lost. 
// Can take in an array or single object
export default function checkForLostRecords(devices) {
  // if locators is already an array, continue, but if its just a single object, turn it into an array for the processing below
  const deviceArr = Array.isArray(devices) ? devices : [devices];
  return deviceArr.reduce((acc, device) => {
    if (!device) {
      acc.isAllLost = false;
    } else {
      const deviceData = device.data;
      const isLost = deviceData?.currentLostRecord ?? deviceData?.data?.currentLostRecord ?? deviceData?.currentLocator ?? deviceData?.data?.currentLocator;
      if (isLost) {
        acc.hasAtLeastOneLost = true;
      } else {
        acc.isAllLost = false;
      }
    }
    return acc;
  }, {
    isAllLost: true,
    hasAtLeastOneLost: false
  });
}